import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SETALLCHARGES, SETMINORDERDELIVERYPRICE } from "../redux/features/CartData";
import CustomerServiceCharge from "../utils/CustomerServiceCharge";
import DiscountPrice from "../utils/DiscountPrice";
import FilterTaxes from "../utils/FilterTaxes";
import MerchentServiceCharge from "../utils/MerchentServiceCharge";
import GetRemainingAmount from "../utils/MinOrderFee";
import Konsole from "../utils/konsole/Konsole";
import { DELIVERY_STATUS } from "../utils/helper";
import { payment_type_card } from "../constant/constant";
import { getPercentage } from "../utils/getPercentage";
import { calculateRoundOff } from "../utils/calculateRoundOff.util";
import useMinimumOrderFees from "./useMinimumOrderFees";
import useSelectedStore from "./useSelectedStore";
const useAllCharges = () => {
  const {
    cartData: { discountCouponTotal, items, itemCount, totalPrice, deliveryCharge, minOrderDeliveryPrice },
    addressData: { selectedAddressType },
    checkoutAddress: { selectedAddress },
    store: { selectedType, selectedStore },
    commonData: { paymentOptionType }
  } = useSelector((state: any) => state);
  const {returnStoreRadiousMinimumFees}=useMinimumOrderFees();
  const {platformFee}=useSelectedStore()
  Konsole.log('deliveryCharge', selectedType)

  const dispatch = useDispatch();
  const [taxes, setTaxes] = useState({ sub_total: 0, tax: [] });
  const [discount, setDiscount] = useState(0);
  const [service_charge, SetService_charge] = useState(0);
  const [remaining_amount, setRemaining_amount] = useState(0);
  const [final_price, setFinal_price] = useState(0);
  const [round_off, setRoundOff] = useState<any>(0)
  const [card_fees, setCard_fees] = useState(0);
  const [merchantFee, setMerchantFee] = useState(0)

  useEffect(() => {
    Konsole.log(selectedStore);
    const tax = FilterTaxes(items);
    const disc = (discountCouponTotal || 0) + DiscountPrice(tax.sub_total, selectedStore, selectedType);
    Konsole.log("disc", tax, disc, tax.sub_total);
    let serv = CustomerServiceCharge(tax.sub_total, selectedStore);

    if(minOrderDeliveryPrice==null || minOrderDeliveryPrice =='' || minOrderDeliveryPrice==undefined){
      dispatch(SETMINORDERDELIVERYPRICE(returnStoreRadiousMinimumFees))
    }

    const rem = GetRemainingAmount(tax.sub_total, disc, selectedStore, selectedType, minOrderDeliveryPrice);

    Konsole.log('minOrderDeliveryPriceAllChanges', minOrderDeliveryPrice)
    // const deliveryChargeCalculate = selectedType == 3 ? (selectedAddressType == 0 ? 0 : 0) : 0;

    // 3 for delivery and 1 for pickup
    const deliveryChargeCalculate = selectedType == 3 ? (selectedAddress?.price || 0) : 0;

    // Konsole.log('asdftotalPricetotalPrice', totalPrice)
    let total = totalPrice + serv - disc + deliveryChargeCalculate; //remaining amount is not added in totalloginb
    const merCharge = MerchentServiceCharge(total, selectedStore); // merchant service fees applied
    // setMerchantFee(merCharge)


    // @@ this is for if payment method is card
    if (paymentOptionType == payment_type_card) {
      let percentage_price = getPercentage(2, total)
      total = paymentOptionType == payment_type_card ? percentage_price + total : total;

      setCard_fees(percentage_price)
    } else {
      setCard_fees(0)
    }
    const commissionFee = merCharge > 0 ? merCharge : serv
    setTaxes(tax);
    setDiscount(disc);
    SetService_charge(serv);
    setRemaining_amount(rem);
    // setFinal_price(total);
    let totalWithRoundOff = calculateRoundOff(total);
    setRoundOff(totalWithRoundOff.roundOff);
    setFinal_price(totalWithRoundOff.finalPrice)
    dispatch(
      SETALLCHARGES({
        discountAmount: disc,
        serviceFee: serv,
        commissionFee: commissionFee, // merchant for priority
        finalPrice: total,
        merServiceFee: merCharge,
        remainingOrder: rem,
        deliveryCharge: deliveryChargeCalculate,
      })
    );
  }, [
    items,
    itemCount,
    totalPrice,
    totalPrice,
    selectedType,
    selectedAddressType,
    selectedAddress,
    deliveryCharge,
    minOrderDeliveryPrice,
    paymentOptionType,
    discountCouponTotal,
    selectedStore,
    returnStoreRadiousMinimumFees,
    platformFee
    // saveAddress?.price,
  ]);

  return [
    taxes,
    discount,
    service_charge,
    remaining_amount,
    final_price + (platformFee || 0),
    totalPrice + (platformFee || 0),
    deliveryCharge,
    card_fees,
    round_off,
    merchantFee
  ];
};

export default useAllCharges;
